"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var framer_motion_1 = require("framer-motion");
var ActiveNavIcon = function () {
    return (react_1.default.createElement(framer_motion_1.motion.svg, { xmlns: 'http://www.w3.org/2000/svg', width: 30, height: 6, viewBox: '0 0 30 6' },
        react_1.default.createElement("defs", null),
        react_1.default.createElement(framer_motion_1.motion.path, { className: 'dynamic-fill', d: 'M30 0c-2.08 0-3.16 1.35-3.96 2.325-.76.937-1.16 1.425-2.04 1.425-.88 0-1.28-.488-2.04-1.425C21.16 1.35 20.12 0 18 0c-2.08 0-3.16 1.35-3.96 2.325-.76.937-1.16 1.425-2.04 1.425-.88 0-1.28-.488-2.04-1.425C9.16 1.35 8.12 0 6 0 3.92 0 2.84 1.35 2.04 2.325 1.28 3.262.88 3.75 0 3.75V6c2.08 0 3.16-1.35 3.96-2.325C4.72 2.738 5.12 2.25 6 2.25c.84 0 1.28.488 2.04 1.425C8.84 4.65 9.88 6 12 6s3.16-1.35 3.96-2.325c.76-.937 1.16-1.425 2.04-1.425.84 0 1.28.488 2.04 1.425C20.84 4.65 21.88 6 24 6c2.08 0 3.16-1.35 3.96-2.325.76-.937 1.16-1.425 2.04-1.425V0z', initial: {
                opacity: 0
            }, animate: {
                opacity: 1
            } })));
};
exports.default = ActiveNavIcon;
